import React from 'react';
import { Link } from 'react-router-dom';

import { Copy, Modal, SystemText } from 'e4shared';
import BlobImage from 'components/blobImage';
import { e4Format, e4Formats } from 'helpers/dates';

export const Comments = ({ history, close, show, comments }) => {
    const goToUser = name => {
        history.push(`/search/${name}`);
    };

    const closeModal = () => {
        close?.();
    };

    const footer = (
        <button className="btn" onClick={closeModal}>
            {SystemText('Pitchback/Comments/Buttons/Close')}
        </button>
    );

    return (
        <Modal show={show} title={SystemText('Pitchback/Comments/Title')} close={closeModal} footer={footer}>
            <div id="conversation">
                {comments?.map(comment => {
                    return (
                        <div key={comment.id} className="user-comment mb10">
                            <div>
                                <button className="btn-link" onClick={() => goToUser(comment.owner_Full_Name)}>
                                    <BlobImage
                                        folder="avatar"
                                        initials={comment.initials}
                                        alt={comment.owner_Full_Name}
                                        src={comment.owner_Avatar}
                                        key={comment.owner_Avatar}
                                    />
                                </button>
                            </div>
                            <div>
                                <div className="mb5">
                                    <Link to={`/search/${comment.owner_Full_Name}`}>{comment.owner_Full_Name}</Link>
                                </div>
                                {comment.date_Added && (
                                    <div className="mb5">{e4Format(comment.date_Added, e4Formats.longWithDay, true)}</div>
                                )}
                                <div className="mb5">
                                    <div className="flex">
                                        <div className="mr20 flex-grow">
                                            <Copy value={comment.comment} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Modal>
    );
};

export default Comments;
